import React from 'react';
import Head from './sections/Head';
import Experience from './sections/Experience';
import Education from './sections/Education';
import Projects from './sections/Projects';
import Footer from './sections/Footer';
import './App.css';

export default function PersonalWebsite() {
  return (
    <div className="flex flex-col min-h-screen w-full font-sans text-gray-800 bg-white overflow-x-hidden">
      
      <Head />
      <Experience />
      <Projects />
      <Education />
      <Footer />

    </div>
  );
}
